import { markThreadAsUnreadMutation } from "@/app/Threads/GraphQL/threadMutations";
import { useThreadMutation } from "@/app/Threads/hooks/useThreadMutation";

export function useMarkThreadAsUnread() {
  return useThreadMutation(markThreadAsUnreadMutation);
}
